import React from 'react';

import Header from './Header';
import ReputationScore from './ReputationScore';
import NetPromoterScore from './NetPromoterScore';
import PrimaryInsights from './PrimaryInsights';
import SecondaryInsights from './SecondaryInsights';
import WordsClouds from './WordsClouds';

const ReportPage = () => {
  
  return (
    <div className='flex flex-col gap-y-10 p-10 bg-[#F9F9F9]'>
      <Header/>
      
      <ReputationScore/>
      <NetPromoterScore/>
      
      <div className='flex gap-x-10'>
        <PrimaryInsights/>
        <SecondaryInsights/>
      </div>
      
      <WordsClouds/>
    </div>
  );
};

export default ReportPage;
